export default "__VITE_ASSET__MYNG0B1f__"